import API from 'services/api';

import { IMessageTemplate } from '../models/IMessageTemplate';

interface IProps {
  reservationId: string;
  payload: IMessageTemplate;
}

export const sendTemplateMessage = ({ reservationId, payload }: IProps): Promise<null> =>
  API.post(`api/accommodation/templates/reservations/${reservationId}/send_message`, payload).then(
    response => response?.data,
  );
